<script>
import { mapGetters } from "vuex";
export default {
  name: "AppMixin",
  computed: {
    ...mapGetters(["currentAppData","isComponentRequest"])
  },
  methods: {
    onSolutionClicked(target,event) {
        if(event)
        event.preventDefault()
      this.trackEvent(
        null,
        `Found solution: solution clicked - ${target.linkName}`
      );

      if(this.isComponentRequest){
          if (!target.openLinkInNewTab) {
              window.parent.location.href = target.linkValue;
          } else {
              window.open(target.linkValue, "_blank");
          }
      }else{
          if (!target.openLinkInNewTab) {
              window.location.href = target.linkValue;
          } else {
              window.open(target.linkValue, "_blank");
          }
      }

    },
    trackEvent(category, subEvent) {
      var title = "Page Hit: " + this.currentAppData.name;
      subEvent = subEvent ? subEvent : `Category clicked : ${category.name}`;
      if(this.$hhMixpanel){
          this.$hhMixpanel.trackEvent(
              category && category.categoryMetaData && category.categoryMetaData.title
                  ? `${title} - ${category.categoryMetaData.title}`
                  : title,
              {
                  subEvent
              }
          );
      }

    }
  }
};
</script>

<style scoped>
</style>